import { useContext } from 'react';

import { ExamEventDetailsEditModalContext } from './exam-event-details-edit-modal-provider';

function useExamEventDetailsEditModal() {
  const context = useContext(ExamEventDetailsEditModalContext);

  if (!context) {
    throw new Error(
      'useExamEventDetailsEditModal must be used within a ExamEventDetailsEditModalProvider',
    );
  }

  return context;
}

export { useExamEventDetailsEditModal };
